module.exports = __webpack_public_path__ + "img/c.cf803d1d.svg";